import Image from "next/image";
import Button from "./Button";
import {useState} from "react";
import SvgArrowDown from "./svg/SvgArrowDown";
import {config} from '@react-spring/web';
import useScrollTo from 'react-spring-scroll-to-hook';
import {useRouter} from "next/router";
import localized from "../locale/locales";

export default function Accordion({items}) {
    const {locale} = useRouter();
    const {jobOffers: lang} = localized[locale];

    const [activeItem, setActiveItem] = useState(null);
    const {scrollTo} = useScrollTo(config.default);

    const handleClick = (e, key) => {
        if (key === activeItem) {
            setActiveItem(null)
        } else {
            setActiveItem(key);

            setTimeout(() => {
                scrollTo(e.target, -150);
            }, 300);
        }
    }

    return (
        <div className="flex flex-col gap-2.5">
            {items.map(({title, body, image}, key) => {
                return (
                    <article className="bg-white rounded-[35px]" key={`AccordionItem: ${key}`}>
                        <div
                            className="w-full bg-gradient-to-tr from-accent-color to-accent-color/50 text-white rounded-[35px]"
                        >
                            <header
                                className="flex items-center justify-between gap-4 p-6 md:py-6 md:px-8 cursor-pointer"
                                onClick={(e) => handleClick(e, key)}
                            >
                                <h3 className="text-md md:text-lg font-semibold">{title}</h3>
                                <button
                                    className="w-14 h-14 bg-white/25 shrink-0 rounded-full inline-flex items-center justify-center">
                                    <SvgArrowDown width={18}
                                                  className={`transform transition-transform duration-500 ${key === activeItem ? 'rotate-180' : ''}`}/>
                                </button>
                            </header>

                            <div className={`accordion ${key === activeItem ? 'accordion-open' : ''}`}>
                                <div
                                    className="px-6 pb-6 md:py-6 md:px-8 flex flex-col md:flex-row gap-6 md:gap-12 items-start">
                                    <div
                                        className="w-full md:max-w-[300px] aspect-[6/5] md:aspect-[5/6] h-full flex relative">
                                        <Image src={image}
                                               lazyBoundary="700px"
                                               className="rounded-[45px]"
                                               objectFit="cover"
                                               objectPosition="top"
                                               layout="fill"
                                               alt=""
                                        />
                                    </div>
                                    <div className="flex-1 flex flex-col gap-8">
                                        <div className="flex flex-col gap-8 max-w-[430px] leading-[1.6]"
                                             dangerouslySetInnerHTML={{__html: body}}/>
                                        {locale !== 'en' && (
                                            <div className="text-center md:text-left">
                                                <Button
                                                    href={`/register?note=${encodeURIComponent(`${lang.common.jobOffer}: ${title}`)}`}
                                                    className="w-full max-w-[260px]">{lang.common.cta}</Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                )
            })}
        </div>
    )
}